import { querySelector, querySelectorAll } from './querySelectors';
import { U_DN_CLASS } from '../config/main';
import { setExpress, EXPRESS_ELEMENT_CLASS, EXPRESS_CHECKBOX_CLASS } from '../scripts/productDetail';
import { getDeliveries } from './productChange';

const UNDER_IMAGES_CLASS = 'js-delivery-item-under-images';
const CHRISTMAS_ITEM_CLASS = 'c-product-christmas';
const DELIVERY_STATUS_ATTR = 'data-delivery-status';
const DELIVERY_TEXT_CLASS = 'js-delivery-text-element';
const DELIVERY_NOTE_CLASS = 'js-delivery-note-element';
const DELIVERY_EXPRESS_CLASS = 'js-delivery-express-element';
const STOCK_ICON_CLASS = 'js-delivery-icon-stock';
const DELIVERY_ICON_CLASS = 'js-delivery-icon-order';
const DELIVERY_ID_ATTR = 'data-delivery-id';
const BLACK_FRIDAY_CLASS = 'c-product-prices__black-friday';

export default function(delivery, pickup, engrave) {
  let deliveries = getDeliveries();
  let newDelivery = deliveries[delivery];
  let expressInput = querySelector(`.${EXPRESS_CHECKBOX_CLASS}`);
  let isExpress = false;

  if (expressInput) {
    isExpress = expressInput.checked;
  }

  if (delivery && newDelivery) {
    let textData = newDelivery;

    if (engrave && newDelivery.engrave) {
      textData = newDelivery.engrave;
    }

    // nastaveni pod obrazkem
    let underImages = querySelector(`.${UNDER_IMAGES_CLASS}`);
    let express = newDelivery.expres;

    if (isExpress && newDelivery.expres) {
      textData = newDelivery.expres;
    }

    if (underImages) {
      underImages.innerHTML = pickup ? textData.under_images_pickup : textData.under_images;
      underImages.setAttribute(DELIVERY_STATUS_ATTR, newDelivery.in_stock ? 'in-stock' : 'on-order'); // 'in-stock' : 'on-order'
    }

    // nastaveni v prouzku s informaci o doprave
    let stockIcon = querySelector(`.${STOCK_ICON_CLASS}`);
    let deliveryIcon = querySelector(`.${DELIVERY_ICON_CLASS}`);
    let deliveryText = querySelector(`.${DELIVERY_TEXT_CLASS}`);
    let deliveryNote = querySelector(`.${DELIVERY_NOTE_CLASS}`);
    let deliveryExpress = querySelector(`.${DELIVERY_EXPRESS_CLASS}`);

    stockIcon.classList.toggle(U_DN_CLASS, newDelivery.in_stock);
    deliveryIcon.classList.toggle(U_DN_CLASS, !newDelivery.in_stock);

    deliveryText.textContent = textData.title;
    deliveryNote.textContent = textData.note;

    deliveryNote.classList.toggle(U_DN_CLASS, express);

    if (deliveryExpress) {
      deliveryExpress.classList.toggle(U_DN_CLASS, !express);
    }

    let christmasItems = querySelectorAll(`.${CHRISTMAS_ITEM_CLASS}`);
    christmasItems.forEach((christmasItem) => {
      christmasItem.classList.toggle(U_DN_CLASS, textData.id !== parseInt(christmasItem.getAttribute(DELIVERY_ID_ATTR), 10));
    });

    let expresses = querySelectorAll(`.${EXPRESS_ELEMENT_CLASS}`);

    expresses.forEach((expressItem) => {
      expressItem.classList.toggle(U_DN_CLASS, !express);
    });

    if (!express) {
      setExpress(false, false);
    }

    let blackFriday = querySelector(`.${BLACK_FRIDAY_CLASS}`);

    if (blackFriday) {
      blackFriday.classList.toggle(U_DN_CLASS, !newDelivery.in_stock);
    }
  }
}
